module.exports = __webpack_public_path__ + "static/media/list-music.c3dbb4d2.svg";